import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  UnsavedChangesDialog,
  UnsavedChangesDialogData,
} from '../../common/unsaved-changes-dialog/unsaved-changes-dialog';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
  /** Optional: provide pre-translated text overrides for the dialog. */
  unsavedChangesDialogData?(): UnsavedChangesDialogData;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
): Observable<boolean> | boolean => {
  if (!component.hasUnsavedChanges()) return true;

  const dialog = inject(MatDialog);
  const data = component.unsavedChangesDialogData?.();
  const ref = dialog.open(UnsavedChangesDialog, { width: '400px', data });
  return ref.afterClosed().pipe(map((confirmed) => !!confirmed));
};
